export const RightPanelTabs = {
    scene: {
        id: 'scene',
        title: '场景设置',
        iconOnly: true,
        iconName: 'sys-settings-outlined',
        content: '',
        titleI18nKey: 'title.sceneSettings',
        isDefault: true
    },
    model: {
        id: 'model',
        title: '模型设置',
        iconName: 'ModelCardOutlined',
        iconOnly: true,
        content: '',
        titleI18nKey: 'title.modelSettings',
        closable: true
    },
    camera: {
        id: 'camera',
        title: '相机设置',
        iconName: 'CameraOutlined',
        iconOnly: true,
        content: '',
        titleI18nKey: 'title.cameraSettings',
        closable: true
    },
    heatmap: {
        id: 'heatmap',
        title: 'Heatmap',
        iconName: 'HeatmapOutlined1',
        iconOnly: true,
        content: '',
        closable: true
    },
    'light': {
        id: 'light',
        title: '光源设置',
        iconName: 'CameraOutlined',
        iconOnly: true,
        content: '',
        titleI18nKey: 'title.lightSettings',
        closable: true
    }
}
